import axios from 'axios';

import { IDisclaimer } from '../infrastructure/interfaces';

export default class DisclaimerService {

  static createDisclaimer(disclaimer: IDisclaimer) {
    return new Promise((resolve, reject) => {
      axios
        .post('/disclaimers', { disclaimer })
        .then((res) => {
          resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }

  static updateDisclaimer(disclaimer: IDisclaimer) {
    return new Promise((resolve, reject) => {
      axios
        .put('/disclaimers', { disclaimer })
        .then((res) => {
          resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }

  static deleteDisclaimer(id: number) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/disclaimers/${id}`)
        .then((res) => {
          const { id } = res.data;
          resolve(id);
        })
        .catch(error => reject(error));
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/DisclaimerService.ts